/**
 * GraphQL Queries for Script Path Management
 * These queries can be used to fetch script mappings from DynamoDB
 */

/* eslint-disable */
// GraphQL queries for ScriptPathMapping table

export const getScriptPathMapping = /* GraphQL */ `
  query GetScriptPathMapping($action_key: String!) {
    getScriptPathMapping(action_key: $action_key) {
      action_key
      script_path
      description
      needsUserInput
      createdAt
      updatedAt
    }
  }
`;

export const listScriptPathMappings = /* GraphQL */ `
  query ListScriptPathMappings(
    $filter: ModelScriptPathMappingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listScriptPathMappings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        action_key
        script_path
        description
        needsUserInput
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

/**
 * Query all script path mappings (typically called on component mount)
 * This provides a way to dynamically load actions from the database
 * instead of hardcoding them in the frontend
 */
export const getAllScriptMappings = /* GraphQL */ `
  query ListScriptPathMappings {
    listScriptPathMappings(limit: 100) {
      items {
        action_key
        script_path
        description
        needsUserInput
        createdAt
        updatedAt
      }
    }
  }
`;
